import { render, staticRenderFns } from "./course-repair-complete.vue?vue&type=template&id=144af0ea&scoped=true&"
import script from "./course-repair-complete.vue?vue&type=script&lang=js&"
export * from "./course-repair-complete.vue?vue&type=script&lang=js&"
import style0 from "./course-repair-complete.vue?vue&type=style&index=0&id=144af0ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144af0ea",
  null
  
)

export default component.exports